import { render, staticRenderFns } from "./orgProjects.vue?vue&type=template&id=26596340&scoped=true"
import script from "./orgProjects.vue?vue&type=script&lang=js"
export * from "./orgProjects.vue?vue&type=script&lang=js"
import style0 from "./orgProjects.vue?vue&type=style&index=0&id=26596340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26596340",
  null
  
)

export default component.exports